module.exports = __webpack_public_path__ + "img/grey_021.0c37b3af.png";